import { BlockUI, NgBlockUI }   from 'ng-block-ui';
import { Component, OnInit }    from '@angular/core';
import { NgbActiveModal }       from '@ng-bootstrap/ng-bootstrap';

import { ApiService }        from '../api/api.service';
import { CompanyQuoteModel } from './models/company.quote';
import { MessagesService }   from '../messages/messages.service';

@Component({
  selector   : 'wor-annual-subscription',
  template: require('./company.annual-subscription.component.html')
})
export class AnnualSubscriptionComponent implements OnInit {
  @BlockUI('annualSubscriptionBlock') block : NgBlockUI;

  quote : CompanyQuoteModel | null = null;

  constructor (
    private activeModal    : NgbActiveModal,
    private apiService     : ApiService,
    private messagesService: MessagesService
  ) {}

  ngOnInit () : void {
    this.block.start();

    this.apiService.get('/company/quote_for_workshop_yearly_conversion')
    .then(( quote : CompanyQuoteModel ) => {
      this.quote = quote;
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
      this.activeModal.dismiss(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  confirm () : void {
    this.block.start();

    this.apiService.get('/company/convert_to_workshop_yearly_from_monthly')
    .then(( wasConverted : boolean ) => {
      this.activeModal.close(wasConverted);

      window.location.href = '#/dashboard';
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }
}
